import { HttpStatus } from '../enums/HttpStatus';

export class ApiException extends Error {
  constructor(
    message: string,
    public code: number,
    args: ApiExceptionConstructorArguments,
  ) {
    super(message);

    this.method = args.method;
    this.apiUrl = args.apiUrl;
    this.requestId = args.requestId;
    this.apiErrorCode = args.apiErrorCode;
  }

  public method: string | undefined;
  public apiUrl: string | undefined;
  public requestId: string | undefined;
  public apiErrorCode: string | undefined;

  public readonly isApiException = true;
}

export type ApiExceptionConstructorArguments = {
  method?: string;
  apiUrl?: string;
  requestId?: string;
  apiErrorCode?: string;
};

export type ApiExceptionConstructor = new (args: ApiExceptionConstructorArguments) => ApiException;

export class BadRequestApiException extends ApiException {
  constructor(args: ApiExceptionConstructorArguments) {
    super(HttpStatus[HttpStatus.BadRequest], HttpStatus.BadRequest, args);
  }
}

export class UnauthorizedApiException extends ApiException {
  constructor(args: ApiExceptionConstructorArguments) {
    super(HttpStatus[HttpStatus.Unauthorized], HttpStatus.Unauthorized, args);
  }
}

export class ForbiddenApiException extends ApiException {
  constructor(args: ApiExceptionConstructorArguments) {
    super(HttpStatus[HttpStatus.Forbidden], HttpStatus.Forbidden, args);
  }
}

export class NotFoundApiException extends ApiException {
  constructor(args: ApiExceptionConstructorArguments) {
    super(HttpStatus[HttpStatus.NotFound], HttpStatus.NotFound, args);
  }
}

export class ConflictApiException extends ApiException {
  constructor(args: ApiExceptionConstructorArguments) {
    super(HttpStatus[HttpStatus.Conflict], HttpStatus.Conflict, args);
  }
}

export class InternalServerErrorException extends ApiException {
  constructor(statusCode: number, args: ApiExceptionConstructorArguments) {
    const message =
      HttpStatus[HttpStatus.InternalServerError] || `InternalServerError, code:${statusCode}`;
    super(message, statusCode, args);
  }
}

export class UnhandledApiErrorException extends ApiException {
  constructor(statusCode: number, args: ApiExceptionConstructorArguments) {
    const message = `Unhandled API error, code:${statusCode}`;
    super(message, statusCode, args);
  }
}

export class UnknownApiErrorException extends Error {
  constructor() {
    const message = `Unknown API error, no response returned`;
    super(message);
  }
}
